// extracted by mini-css-extract-plugin
module.exports = {"articleContainer":"lcResourcesArticles_articleContainer__7aKXg","title":"lcResourcesArticles_title__rrwlE","moreArticle":"lcResourcesArticles_moreArticle__9ozSO"};